import { useMultipleChoiceExam } from '../../hooks/useMultipleChoiceExam';
import CollectingData from '../../../../../containers/CollectingData';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import ExamStream from '../../components/ExamStream';
import PreExam from '../../components/PreExam';
import ExamBox from '../../components/ExamBox';
import styles from './style.module.scss';
import { useState } from 'react';

/** Lays out the exam itself: the screen for the current phase, plus the proctoring sidebar. */
function Exam() {
    // Only the camera preview knows whether it came up, and only the entrance screen cares.
    const [isCameraActive, setIsCameraActive] = useState(false);

    const {
        next,
        phase,
        detail,
        action,
        userId,
        counter,
        question,
        jobTitle,
        language,
        languages,
        exitExam,
        webcamRef,
        isLoading,
        startExam,
        skipQuestion,
        selectedOption,
        canSkipQuestion,
        setLanguage,
        setSelectedOption,
    } = useMultipleChoiceExam();

    return (
        <MotionWrapper className={styles.wrapper}>
            {phase === 'PreExam' && <PreExam
                detail={detail}
                action={action}
                loading={isLoading}
                onStart={startExam}
                language={language}
                languages={languages}
                onSelectLanguage={setLanguage}
                isCameraActive={isCameraActive}
            />}

            {phase === 'Question' && <ExamBox
                userId={userId}
                onNext={next}
                counter={counter}
                loading={isLoading}
                question={question}
                jobTitle={jobTitle}
                onSkip={skipQuestion}
                canSkip={canSkipQuestion}
                selectedOption={selectedOption}
                onSelectOption={setSelectedOption}
            />}

            {phase === 'CollectingData' && <CollectingData
                progress={100}
                description='Please remain on this page while we collect your data.'
            />}

            {/* Kept mounted across questions: remounting it would restart the recording. */}
            {phase !== 'CollectingData' && <ExamStream
                counter={counter}
                onExit={exitExam}
                webcamRef={webcamRef}
                showCountdown={phase === 'Question'}
                onCameraChange={setIsCameraActive}
            />}
        </MotionWrapper>
    )
};

export default Exam;
